// eslint-disable-next-line global-require, import/no-dynamic-require
export const PACKAGE_VERSION = require('../../package.json').version;

// Api 平台类型key
export const PLATFORM_API_KEY = 'ymba-mwapi-platform';
// H5 平台类型code
export const H5_PLATFORM_CODE = 'h5';
// PC 平台类型code
export const PC_PLATFORM_CODE = 'pc';

// 页面高度补差值
export const PAGE_HEIGHT_OFFSET = 10;

// API 请求前缀
export const API_REQUEST_PREFIX = '/mwapi/V5';

// 基础URL
export const BASE_URL = '';

// 首页
export const HOME_URL = `${BASE_URL}/`;

// 列表限制条数
export const LIMIT = 10;

// 人民币单位
export const RMB_UNIT = '¥';

// 用户token 缓存key
export const TOKEN_NAME = 'ymba-mwapi-token';

// 小程序已登录Token
export const MINI_PROGRAM_TOKEN_NAME = 'ymba-mini-token';

// APP已登录Token
export const APP_TOKEN_NAME = 'ymba-mapi-token';

// 用户ID 缓存key
export const UID_NAME = 'YMBA-UID';

// 重定向缓存key
export const REDIRECT_NAME = 'ymbaMWRedirect';

// 微信录音权限缓存key
export const RECORD_AUTH_NAME = 'ymbaMWRecordAuth';

// 轮询最大次数
export const MAX_POLL = 60;

// 短信验证码相隔时长（秒）
export const SMS_CODE_DURATION = 60;

// 每秒
export const PER_SECOND = 1000;

// 每分钟
export const PER_MINUTE = PER_SECOND * 60;

// 每小时
export const PER_HOUR = PER_MINUTE * 60;

// 每天
export const PER_DAY = PER_HOUR * 24;

// 微信录音最大时长（秒）
export const MAX_RECORD_DURATION = 60;

// 弹窗信息缓存key
export const ALERT_MESSAGE_NAME = 'YMBA_MWAPI_ALERT_MESSAGE';

// 咨询电话
export const CONSUMER_HOTLINE = '400-809-3885';

// 微信服务号
export const SERVICE_NUMBER = 'xiyouEDU';

// 自动下一首播放设置缓存key
export const AUTOPLAY_NEXT_SETTING_NAME = 'YMBA-SETTING-AUTOPLAY-NEXT';

// 自动下一首可设置项
export const AUTOPLAY_SETTINGS = [{
  title: 'Wi-Fi和4G下均开启',
  key: 'all',
}, {
  title: '不开启',
  key: 'off',
}];

// 自动停止时间设置缓存key
export const TURN_OFF_TIME_SETTING_NAME = 'YMBA-SETTING-TURN-OFF-TIME';

// 播放完节目停止标志
export const TURN_OFF_PROGRAM_IDENTIFICATION = '#program@';
// 播放到时间停止标志
export const TURN_OFF_TIME_IDENTIFICATION = '#time@';

// 自动停止可设置项
export const TURN_OFF_TIME_SETTINGS = [{
  title: '不开启',
  key: 'off',
}, {
  title: '15分钟后',
  key: `15${TURN_OFF_TIME_IDENTIFICATION}m`,
}, {
  title: '30分钟后',
  key: `30${TURN_OFF_TIME_IDENTIFICATION}m`,
}, {
  title: '60分钟后',
  key: `60${TURN_OFF_TIME_IDENTIFICATION}m`,
}, {
  title: '90分钟后',
  key: `90${TURN_OFF_TIME_IDENTIFICATION}m`,
}, {
  title: '播完当前讲',
  key: `1${TURN_OFF_PROGRAM_IDENTIFICATION}`,
}];

// 优惠活动标志
export const DISCOUNT_IDENTIFICATION = '@discount';

// 优惠码标志
export const COUPON_IDENTIFICATION = '@coupon';

// 项目事件打点配置key
export const EVENT_LOG_CONFIG_NAME = 'ymbaMWEventLogConfig';

// 提示信息缓存key
export const PROMPT_MESSAGE_NAME = 'ymbaMWPromptMessage';

// 媒体错误code 解析
// https://developer.mozilla.org/zh-CN/docs/Web/API/MediaError
export const MEDIA_ERROR_CODE = {
  // 被中断
  1: {
    name: 'MEDIA_ERR_ABORTED',
    message: '音频加载被中断',
  },
  // 网络错误
  2: {
    name: 'MEDIA_ERR_NETWORK',
    message: '网络错误，请稍后重试',
  },
  // 解析错误
  3: {
    name: 'MEDIA_ERR_DECODE',
    message: '音频解析错误',
  },
  // 不支持该类型
  4: {
    name: 'MEDIA_ERR_SRC_NOT_SUPPORTED',
    message: '不支持当前音频类型',
  },
};

// render join price 开团类型
export const RENDER_JOIN_PRICE_TARGET_TYPE = 'createGroupbuyTeam';

// 节目视频资源类型
export const PROGRAM_AUDIO_MEDIA_TYPE = 'audio';
// 节目视频资源类型
export const PROGRAM_VIDEO_MEDIA_TYPE = 'mp4';

// 最后播放的节目ID
export const PLAYER_LAST_PROGRAM_ID = 'ymba-player-program-id-';

// 节目已播时间缓存key 前缀
export const PLAYED_TIME_PREFIX = 'ymba-played-time-';
// 节目已播时间段最大缓存数量
export const PLAYED_TIME_RANGE_MAX = 9999;

// 开团订单类型
export const CREATE_GROUP_BUY_TEAM_TARGET_TYPE = 'groupbuyTeam';

// 参团订单类型
export const JOIN_GROUP_BUY_TEAM_TARGET_TYPE = 'groupbuyMember';

// 输入框节点名称
export const INPUT_NODE_NAME = 'INPUT';
export const TEXTAREA_NODE_NAME = 'TEXTAREA';

// 项目App 路由配置
export const APP_ROUTE_MAP = 'ymbaMWAppRouteMap';
// mini UA 标志
export const MINI_USER_AGENT_SYMBOL = 'miniprogram';
// iPhone UA 标志
export const IPHONE_USER_AGENT_SYMBOL = 'YMBAiPhone';
// Android UA 标志
export const ANDROID_USER_AGENT_SYMBOL = 'YMBAAndroidPhone';
// App 路由添加token 白名单
export const APP_ROUTE_TOKEN_WHITE_LIST = ['CreateWork', 'Pay'];

// 微信分享配置默认参数
export const WECHAT_SHARE_DEFAULT_PARAMS = {
  title: '少年商学院',
  desc: '在家上世界名校通识课',
  imgUrl: 'https://www.youthmba.com/files/default/share.png',
  qZoneTitle: '少年商学院',
  link: window.location.href,
};

// 搜索历史最大缓存数
export const SEARCH_HISTORY_MAX = 5;
// 搜索历史缓存key
export const SEARCH_HISTORY_NAME = 'ymbaMWSearchHistory';
// 搜索历史缓存分割标志
export const SEARCH_HISTORY_SPLIT_SYMBOL = ',';
// 搜索结果为课程内容时的类型
export const SEARCH_RESULT_COURSE_CONTENT_BLOCK_TYPE = 'content';
// 搜索结果课程内容是音频节目类型
export const SEARCH_RESULT_CONTENT_PROGRAM_TYPE = 'program';
// 搜索结果课程内容是直播课时节目类型
export const SEARCH_RESULT_CONTENT_LESSON_TYPE = 'courseLesson';

// 支付打点映射
export const PAY_ACTION_SOURCE_MAP = {
  popup: 'PAY_POPUP',
  payCenter: 'PAY_FORM',
};
// 产品列表点击打点映射
export const PRODUCT_CLICK_MAP = {
  list: 'LIST_CLICK',
  small: 'SMALL_GRID_CLICK',
  large: 'LARGE_GRID_CLICK',
  fullScreen: 'FULLSCREEN_GRID_CLICK',
};
// 产品列表点击曝光映射
export const PRODUCT_EXPOSURE_MAP = {
  list: 'LIST_EXPOSURE',
  small: 'SMALL_GRID_EXPOSURE',
  large: 'LARGE_GRID_EXPOSURE',
  fullScreen: 'FULLSCREEN_GRID_EXPOSURE',
};

// 学习计划调查填写状态
export const PLAN_SURVEY_FINISH_STATUS = 'plan-survey-finish-status';

// 积分分享产品海报
export const POINT_SHARE_PRODUCT_POSTER = [{
  templateKey: 'green',
  active: false,
  draw: false,
  finished: false,
  resultImg: '',
}, {
  templateKey: 'red',
  active: false,
  draw: false,
  finished: false,
  resultImg: '',
}, {
  templateKey: 'black',
  active: false,
  draw: false,
  finished: false,
  resultImg: '',
}];

// 积分分享产品海报默认index
export const POINT_SHARE_PRODUCT_POSTER_DEFAULT_INDEX = 0;

// YMUI Tag 类型与以前数据匹配
export const UI_TAG_TYPE_MAP = {
  default: 'default',
  'gradient-highlight': 'gradient-highlight',
  primary: 'gradient-primary',
  disabled: 'disabled',
  gradient: 'gradient-primary',
  highlight: 'highlight',
  'black-gold': 'gradient-black-gold',
  gold: 'gold',
};

export const UI_SYMBOL_TYPE_MAP = {
  default: 'default',
  'gradient-highlight': 'gradient-highlight',
  primary: 'primary-light',
  disabled: 'disabled',
  gradient: 'gradient-primary',
  highlight: 'highlight',
  'black-gold': 'gradient-black-gold',
  gold: 'gold',
};

// 是否展示过播放器位置提示弹窗
export const PLAYER_POSITION_HINT_POPUP_SHOW = 'ym-player-position-hint-popup-show';

// 是否关闭过播放器操作栏
export const PLAYER_ACTION_BAR_CLOSE = 'ym-player-action-bar-close';

// 播放器播放列表缓存
export const PLAYER_NEWEST_PLAYLIST = 'ym-player-newest-playlist';

// 播放器播放列表排序
export const PLAYER_PLAY_LIST_SORT = 'ym-player-playlist-sort';

// 播放器倍速
export const PLAYER_SPEED_PLAY = 'ym-player-speed-play';

// 下载栏高度缓存key
export const DOWNLOAD_BAR_HEIGHT_KEY = 'ymbaDownloadBarHeight';

// 会员中心权益展示NEW badge缓存前缀
export const MY_VIP_RIGHT_SHOW_NEW_KEY_PREFIX = 'ymbaMyVipRightNew-';
// 会员中心权益自动点击缓存前缀
export const MY_VIP_RIGHT_ONCE_CLICK_KEY_PREFIX = 'ymbaMyVipRightOnceClick-';
